import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './navnova.css';

const Navnova = () => {
    const [submenu, setSubmenu] = useState([{ id_menu: "", name_pt: "", name_en: "" }])
    const [menu, setMenu] = useState([{}])
    const [menu1, setMenu1] = useState("menu2")
    const [select, setSelect] = useState()
    const mn = useParams().menu;

    useEffect(() => {
        fetch("https://nathivos.com.br/backend/select/u446777955_app/main_menu")
            .then(r => r.json())
            .then(r => {
                setMenu(r)
            })
        fetch("https://nathivos.com.br/backend/select/u446777955_app/sub_menu")
            .then(r => r.json())
            .then(r => {
                setSubmenu(r)
            })
    }, [])

    const handleTitle = (pt) => {
        document.title = pt
    }
    const handleMenu = () => {
        setMenu1(menu1 === "menu1" ? "menu2" : "menu1")
        setSelect(null)
    }
    const handleAcordion = (id) => {
        setSelect(id === select ? null : id)        
    }

    return (
        <nav className="navbar">
            <header className={mn === undefined ? "logo active" : "logo"}>
                <Link to={"/"} onClick={()=> setMenu1("menu2")}> Nathivo's </Link>
            </header>
            <div className="menu_mobil" onClick={handleMenu}>
                {menu1 === "menu1" && <i className="fa fa-times fa-2x" aria-hidden="true"></i>}
                {menu1 === "menu2" && <i className="fa fa-bars fa-2x" aria-hidden="true"></i>}
            </div>
            <div className={menu1}>
                <div className="menu" >
                    {menu?.map((itm, a) =>
                        <div className="dropdown" key={a}>
                            <Link to={"/" + itm.link} className={"dropbtn menu_item"} onClick={() => { handleTitle(itm.name_pt) }}>
                                <span className={itm.link === mn ? "active" : ""}>{itm.name_pt}</span>
                            </Link>
                            <div className={"dropdown-content"}>
                                {submenu.filter((item) => item.link_menu === itm.link).map((item, i) =>
                                    <Link to={"/" + itm.link + "/" + item.link} className={"dropdown_item"} key={a + i} onClick={() => handleTitle(item.name_pt)}>
                                        <span>{item.name_pt}</span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className="menu_mobel_2">
                    {menu?.map((itm, a) =>
                        <div className="dropdown" key={a}>
                            <div to={"/" + itm.link} className={"menu_mobel_item"} onClick={() => handleAcordion(a)}>
                                <span>{itm.name_pt}</span>
                                <div className={select === a ? "menu_mobel_content_show" : "menu_mobel_content"} onClick={handleMenu}>
                                    {submenu.filter((item) => item.link_menu === itm.link).map((item, i) =>
                                        <Link to={"/" + itm.link + "/" + item.link} className={"menu_mobel_subitem"} key={a + i} onClick={() => handleTitle(item.name_pt)}>
                                            <span>{item.name_pt}</span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="menu_mobel" onClick={handleMenu}> </div>
            </div>
        </nav >
    )
}


export default Navnova;